import { useTranslation } from 'react-i18next';

import { Field } from '../Form/Field/Field';
import { Input } from '../Form/Input/Input';
import { useTableContext } from './TableRoot.context';
import { tableSearchStyle } from './TableSearch.css';

export const TableSearch = () => {
  const { setGlobalFilter, state } = useTableContext();
  const { t } = useTranslation(['common']);

  return (
    <Field.Root className={tableSearchStyle}>
      <Field.Label srOnly>{t('common:datatable.search')}</Field.Label>
      <Input
        clearable
        icon="Search"
        onValueChange={(value) => setGlobalFilter(value)}
        placeholder={t('common:datatable.search')}
        type="search"
        value={state.globalFilter ?? ''}
      />
    </Field.Root>
  );
};
